import React, { useState, useRef, useEffect } from 'react';
import Denglong from '@public/images/denglong.svg'
import './index.less'

const Navigation = (props) => {
  const { logo, list = [], active } = props
  const submenuRef = useRef(null)
  return <div className="navbar">
    <div className="navbar-inner">
      {
        logo
          ? <img src={logo} alt="logo" />
          : null
      }
      <ul className="navbar-inner-list">
        {
          list.map((item, index) => {
            return <li key={index} className={`${active === index ? "nav-li nav-active" : "nav-li"}`} ref={submenuRef}>
              {item.name === "新春活动" ? <Denglong className="nav-spring-icon" /> : null}
              <a href={item.path} className={`${item.name === "新春活动" ? "nav-spring" : ""} ${active === index && item.name === "新春活动" ? "nav-spring-active" : ""}`}>{item.name}</a>
            </li>
          })
        }
      </ul>
    </div>
  </div>
}



export default Navigation
